import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { SettingsVehicleReleaseDateInformationDto, vehicleReleaseDateInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface VehicleReleaseAddEditDialogProps {
  initialValues: SettingsVehicleReleaseDateInformationDto
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function VehicleReleaseAddEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: VehicleReleaseAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={vehicleReleaseDateInformationValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Vehicle Release Date</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(
                        touched.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT &&
                          errors.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT
                      )}
                      helperText={
                        touched.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT &&
                        errors.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT
                      }
                      label='Days Since Conformity Submitted'
                      name='vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>
                    ||All fields are required. || This is typically configured as 30 days due to the 30-day vehicle hold
                    required by the DOT. ||
                  </ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={isLoading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
